<template>
	<div>
		<div class="backgroundImage"></div>
		<div class="ke">
			<div class="top">
				<div class="container">
					<el-breadcrumb separator="/" style="padding-top: 40px;">
						<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
						<el-breadcrumb-item :to="{ path: '/complianceStudy' }">药销通合规学苑</el-breadcrumb-item>
						<el-breadcrumb-item>合规培训</el-breadcrumb-item>
					</el-breadcrumb>
					<div style="margin-top: 80px;" class="flex-row">
						<div class="bigImg flex-row flex-center"><el-image :src="$route.query.profile" fit="cover"></el-image></div>
						<div class="top-font">
							<div>{{ $route.query.name }}</div>
							<div class="font-child">{{ $route.query.title }}</div>
							<div class="flex-center justify-between"></div>
							<div style="white-space:pre-wrap">{{ $route.query.description }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="main">
			<div class="special">
				<div></div>
				<div>专栏</div>
			</div>
			<div class="card">
				<div v-for="(i, index) in classList" :key="index" @click="toOpen" class="cursor card-item flex-column justify-between">
					<div class="img"><el-image :src="i.advertisingPic" fit="cover"></el-image></div>
					 <el-tooltip :disabled="i.status" class="" effect="light"  placement="top">
					      <div slot="content" class="tooltipTitle">
					      	<div>{{ i.title }}</div>
					      </div>
						  <span>{{ i.title }}</span>
					    </el-tooltip>
					<div class="flex-row justify-between">
						<span>{{ i.creationTime }}</span>
						<div class="immediately">
							立即咨询>>
							<div class="second-menu-icon">
								<div><img src="@/assets/footer/service.png" /></div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="block" style="text-align: center;">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page.sync="currentPage"
					:page-size="pageSize"
					layout="prev, pager, next, jumper"
					:total="total"
				></el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
import moment from 'moment';
import { getLearningMaterialList } from '@/api/complianceStudy/complianceStudy.js';
export default {
	name: 'classroom',
	components: {},
	data() {
		return {
			currentPage: 1,
			pageSize: 9, //每页显 示的数量
			total: 10,
			industryExpertId: '',
			classList: []
		};
	},
	mounted() {
		this.industryExpertId = this.$route.query.id;
		this.getLearningMaterialList(this.currentPage);
	},
	methods: {
		getLearningMaterialList(pageIndex) {
			let obj = {
				pageIndex: pageIndex,
				pageSize: 9,
				industryExpertId: this.industryExpertId,
				materialType: 2
			};
			getLearningMaterialList(obj).then(({ data: res }) => {
				this.classList = res.data.items;
				this.classList.map(item => {
					item.creationTime = moment(item.creationTime).format('YYYY-MM-DD');
					// item.title='啊实打实大师大师大师大师的啊实打实大师大师大师大师的啊实打实大师大师大师大师的啊实打实大师大师大师大师的啊实打实大师大师大师大师的';
					item.status = item.title.length>38?false:true;
					return item;
				});
				this.total = res.data.totalCount;
			});
		},
		handleSizeChange() {},
		handleCurrentChange() {
			this.getLearningMaterialList(this.currentPage);
		},
		toOpen() {}
	}
};
</script>

<style lang="scss" scoped>
.bigImg {
	width: 518px;
	height: 291px;
}
.backgroundImage {
	position: absolute;
	top: 0px;
	width: 100%;
	height: 518px;
	background-image: url('../../assets/complianceStudy/backgroundImage.png');
	background-repeat: no-repeat;
}
.ke {
	height: 543px;
}
.top {
	z-index: 99;
	height: 543px;
	margin-top: 80px;
	// background-color: #e5eaff;

	.top-font {
		color: #333333;
		width: 518px;
		margin-left: 60px;

		div:first-child {
			margin-bottom: 20px;
			// width: 48px;
			text-align: left;
			height: 33px;
			font-size: 24px;
			font-weight: 600;
			line-height: 33px;
		}

		div:last-child {
			margin-top: 30px;
			width: 502px;
			height: 72px;
			font-size: 14px;
			font-weight: 400;
			line-height: 24px;
		}

		.font-child {
			white-space: pre-wrap;
			// margin-top: 10px;
			width: 308px;
			height: 100px;
			font-size: 18px;
			font-weight: 600;
			line-height: 35px;
		}
	}
}

.container {
	position: absolute;
	z-index: 9;
	left: calc(50% - 600px);
	margin: 0 auto;
	width: 1200px;
}

.special {
	width: 76px;
	height: 40px;
	font-size: 28px;
	margin: 30px 0;
	font-weight: 600;
	color: #333333;
	// background-color: red;
	text-align: center;
	line-height: 40px;
	position: relative;

	:first-child {
		position: absolute;
		bottom: 0;
		width: 86px;
		height: 16px;
		background: #2970ec;
		opacity: 0.52;
	}
	:last-child {
		left: 13px;
		position: absolute;
		z-index: 9;
	}
}

.card {
	display: flex;
	// align-content: flex-start;
	flex-wrap: wrap;
	// justify-content: center;
}

.card-item {
	position: relative;
	margin-right: 30px;
	width: 367px;
	height: 282px;
	background: #ffffff;
	margin-bottom: 49px;
	box-shadow: 0px 5px 8px 0px rgba(212, 212, 212, 0.5), 0px -5px 8px 0px rgba(225, 225, 225, 0.5);
	border-radius: 4px;
	transition: all 0.3s;
	overflow: hidden;
	.tooltip{
		height: 300px;
		background-color: red;
	}
	.img {
		width: 100%;
		height: 161px;
		background-color: #8fc31f;
	}
	& > :nth-child(2) {
		// margin-top: 15px;
		text-align: left;
		padding: 0 10px;
		font-size: 18px;
		font-weight: 600;
		color: #333333;
		line-height: 25px;
		height: 50px;
		overflow:hidden;
		text-overflow:ellipsis;
		display:-webkit-box;
		-webkit-line-clamp:2;
		-webkit-box-orient:vertical;
		word-break:break-all;
		// overflow: hidden;
		// text-overflow: ellipsis;
		// display:-webkit-box;
		// -webkit-line-clamp:2;
		// // white-space: nowrap;
	}

	> :last-child {
		// margin-top: 15px;
		padding: 0 10px;
		height: 20px;
		font-size: 14px;
		color: #666666;
		line-height: 20px;
		margin-bottom: 20px;
		.immediately {
			color: $global-default-primary;
			// padding-right: 20px;
		}
	}
}

.card .second-menu-icon {
	width: 367px;
	height: 282px;
	transition: opacity 2s;
	display: none;
	right: 0px;
	top: 0px;
	z-index: 2;
	border-radius: 4px;
	position: absolute;
	background: rgba(0, 0, 0, 0.25);
	align-items: center;
	> :first-child {
		position: absolute;
		top: calc(50% - 90px);
		left: calc(50% - 90px);
		width: 180px;
		height: 180px;
		img {
			width: 100%;
		}
	}
}
.card-item:hover {
	transform: scale(1.03);
	transform: translateY(-10px);
	// margin-top: -10px;
}
.immediately:hover .second-menu-icon {
	display: block;
}
</style>
